import { ClbDropdown } from "@celebration/react/ClbDropdown/ClbDropdown";
import { ClbDropdownBody } from "@celebration/react/ClbDropdown/ClbDropdownBody/ClbDropdownBody";
import { ClbDropdownTrigger } from "@celebration/react/ClbDropdown/ClbDropdownTrigger/ClbDropdownTrigger";
import type { DropdownProps } from "@components/contracts/Dropdown.types";
import type React from "react";
import { useState } from "react";

export const CelebrationDropdown: React.FC<DropdownProps> = ({
  children,
  position,
  trigger,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const close: VoidFunction = () => setIsOpen(false);

  return (
    <ClbDropdown
      isOpen={isOpen}
      dropdownPosition={position}
      onOpen={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
    >
      <ClbDropdownTrigger>{trigger}</ClbDropdownTrigger>
      <ClbDropdownBody>{children(close)}</ClbDropdownBody>
    </ClbDropdown>
  );
};
